import { Component, ChangeDetectionStrategy, inject, OnInit, ElementRef, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { CasesService } from './services/cases.service';
import { PRIORITY_FILTERS, STATUS_FILTERS } from './models/ticket.models';
import { CaseStatsBarComponent } from './components/case-stats-bar/case-stats-bar.component';
import { CaseFilterChipsComponent } from './components/case-filter-chips/case-filter-chips.component';
import { CaseCardComponent } from './components/case-card/case-card.component';
import { CaseDetailPanelComponent } from './components/case-detail-panel/case-detail-panel.component';

@Component({
  selector: 'app-cases',
  standalone: true,
  imports: [
    CommonModule,
    CaseStatsBarComponent,
    CaseFilterChipsComponent,
    CaseCardComponent,
    CaseDetailPanelComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
})
export class CasesComponent implements OnInit {
  casesService = inject(CasesService);
  private route = inject(ActivatedRoute);

  casesListEl = viewChild<ElementRef<HTMLDivElement>>('casesList');

  priorityFilters = PRIORITY_FILTERS;
  statusFilters = STATUS_FILTERS;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const orgId = params['organizationId'] ? Number(params['organizationId']) : null;
      this.casesService.loadTickets(orgId);
    });
  }

  onPriorityFilter(value: string | null): void {
    this.casesService.setPriorityFilter(value);
  }

  onStatusFilter(value: string | null): void {
    this.casesService.setStatusFilter(value);
  }

  onCardClicked(ticket: { request_id: string }): void {
    this.casesService.selectTicket(ticket.request_id);
  }

  onListScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight;

    // Trigger load when within 200px of bottom
    if (scrollBottom < 200) {
      this.casesService.loadNextPage();
    }
  }
}
